import axios from "axios";
import { User } from "../models/user";
import { error, getAxiosConfig } from "../core/common_functions";
import { GenericRequestResult } from "../core/common_types";
import { Accessorio, Option } from "../models/door_configuration";

export const useAccessoriesApi = () => {
    const area = "accessories";

    return {
        async findMotorizationsByCategory(currentUser: User, categoryId: number): Promise<GenericRequestResult<Accessorio[]>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/motorizations/findByCategory?categoryId=${categoryId}`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },

        async findMotorizationAccessoriesByCategory(currentUser: User, categoryId: number): Promise<GenericRequestResult<Accessorio[]>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/motorization-accessories/findByCategory?categoryId=${categoryId}`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },

        async findGenericAccessoriesByCategory(currentUser: User, categoryId: number): Promise<GenericRequestResult<Accessorio[]>> {
            try {
                let response = await axios.get(`${process.env.REACT_APP_API_URL}/${area}/generic-accessories/findByCategory?categoryId=${categoryId}`, getAxiosConfig(currentUser));

                return response.data;
            } catch (e: any) {
                throw error(e);
            }
        },
    }
}